import React, { Suspense } from 'react';
import { Spin } from 'antd';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './dashboard';
import Ecommerce from './ecommerce';
import Products from './product';
import Addons from './addons';
import Promos from './promos';
import Settings from './settings';
import Customers from './customers';
import withAdminLayout from '../../layout/withAdminLayout';

const Admin = () => {
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="ecommerce/*" element={<Ecommerce />} />
        <Route path="products/*" element={<Products />} />
        <Route path="addons/*" element={<Addons />} />
        <Route path="promos/*" element={<Promos />} />
        <Route path="settings/*" element={<Settings />} />
        <Route path="customers/*" element={<Customers />} />
        <Route path="/" element={<Dashboard />} />
      </Routes>
    </Suspense>
  );
};

export default withAdminLayout(Admin);
